import translations from "./locales"

const i18n = {
  locale: document.documentElement.lang || "en",
  defaultLocale: "en",

  t(key, options = {}) {
    const locale = this.locale
    const keys = key.split('.')

    // Try current locale, fallback to default
    let value = this._lookup(keys, translations[locale])
              || this._lookup(keys, translations[this.defaultLocale])
              || key

    // Handle interpolation: %{variable}
    if (typeof value === 'string' && options) {
      Object.keys(options).forEach(k => {
        value = value.replace(new RegExp(`%\\{${k}\\}`, 'g'), options[k])
      })
    }

    return value
  },

  _lookup(keys, obj) {
    if (!obj) return null
    let result = obj
    for (const k of keys) {
      if (result && typeof result === 'object' && k in result) {
        result = result[k]
      } else {
        return null
      }
    }
    return result
  }
}

window.I18n = i18n

export default i18n
